import { render, staticRenderFns } from "./ConfirmOrders.vue?vue&type=template&id=85c22a02&"
import script from "./ConfirmOrders.vue?vue&type=script&lang=js&"
export * from "./ConfirmOrders.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmOrders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports